module.exports = __webpack_public_path__ + "img/RecurringBlue.2591fba3.svg";